import React from "react";
import { Modal, Button } from "antd";
import {
  FileTextOutlined,
  UserOutlined,
  HomeOutlined,
  EnvironmentOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import "./viewUserQueryProject.css";

const formatDate = (d) =>
  d
    ? new Date(d).toLocaleDateString("en-IN", { year: "numeric", month: "short", day: "numeric" })
    : "—";

const UserQueryProjectViewModal = ({ visible, recordData, onClose }) => {
  const d = recordData || {};
  const user = d.user || {};

  return (
    <Modal
      title={
        <div className="view-uqp-modal-header-content">
          <FileTextOutlined className="view-uqp-modal-header-icon" style={{ color: "white" }} />
          <span style={{ color: "white" }}>QUERY DETAILS</span>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      width={640}
      className="view-uqp-modal-override"
      styles={{
        header: {
          background: "#070C18",
          borderRadius: "12px 12px 0 0",
          padding: "16px 24px",
          borderBottom: "none",
        },
        body: { padding: "20px 24px", background: "#f5f6fa" },
      }}
    >

      {/* ── Project Info ── */}
      <div className="view-uqp-card">
        <h3 className="view-uqp-card-header"><HomeOutlined /> Project Information</h3>
        <div className="view-uqp-info-grid">

          <div className="view-uqp-info-item" style={{ gridColumn: "1 / -1" }}>
            <span className="view-uqp-info-label">Project Name</span>
            <span className="view-uqp-info-value view-uqp-info-value--strong">{d.project_name || "—"}</span>
          </div>

          <div className="view-uqp-info-item">
            <span className="view-uqp-info-label">Builder Name</span>
            <span className="view-uqp-info-value">{d.builder_name || "—"}</span>
          </div>

          <div className="view-uqp-info-item">
            <span className="view-uqp-info-label"><CalendarOutlined /> Created</span>
            <span className="view-uqp-info-value">{formatDate(d.created_at)}</span>
          </div>

          <div className="view-uqp-info-item" style={{ gridColumn: "1 / -1" }}>
            <span className="view-uqp-info-label"><EnvironmentOutlined /> Street Address</span>
            <span className="view-uqp-info-value">{d.street_address || "—"}</span>
          </div>

        </div>
      </div>

      {/* ── User Info ── */}
      <div className="view-uqp-card" style={{ marginTop: 14 }}>
        <h3 className="view-uqp-card-header"><UserOutlined /> Submitted By</h3>
        {user?._id ? (
          <div className="view-uqp-info-grid">
            <div className="view-uqp-info-item">
              <span className="view-uqp-info-label">Name</span>
              <span className="view-uqp-info-value">{user.name || "—"}</span>
            </div>
            <div className="view-uqp-info-item">
              <span className="view-uqp-info-label">Email</span>
              <span className="view-uqp-info-value">{user.email || "—"}</span>
            </div>
            <div className="view-uqp-info-item">
              <span className="view-uqp-info-label">Contact</span>
              <span className="view-uqp-info-value">
                {user.contact_number ? `${user.country_code || ""} ${user.contact_number}` : "—"}
              </span>
            </div>
          </div>
        ) : (
          <div className="view-uqp-empty-note">No user information available.</div>
        )}
      </div>

      {/* ── Actions ── */}
      <div className="view-uqp-actions">
        <Button size="large" onClick={onClose} className="view-uqp-btn-close">
          Close
        </Button>
      </div>

    </Modal>
  );
};

export default UserQueryProjectViewModal;